import { render, staticRenderFns } from "./controlPanel.vue?vue&type=template&id=3265f3dc&scoped=true&"
import script from "./controlPanel.vue?vue&type=script&lang=js&"
export * from "./controlPanel.vue?vue&type=script&lang=js&"
import style0 from "./controlPanel.vue?vue&type=style&index=0&id=3265f3dc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3265f3dc",
  null
  
)

export default component.exports